import { FormWithRedux } from '../../FormWithRedux';
import { EDChestPainPathwayInformationForm} from './EDChestPain-PathwayInformationForm';

export class EDChestPainIntroForm extends FormWithRedux {

    constructor() {
        super('introForm');
    }

    generateSubform(identifier) {
        switch (identifier) {
            case 'pathwayInformationForm':
                return new EDChestPainPathwayInformationForm();
        }
    }

    shouldDisplayFormDetailForIdentifier() {
        return true;
    }

    isEnabled(identifier) {
        if (identifier != null) {
            return true;
        }
        return false;
    }

    isMandatory() {
        return false;
    }

    getValueType() {
        return null;
    }

    submissionValidation() {
        return [];
    }

    detailString() {
        return this.detail;
    }
}


// WEBPACK FOOTER //
// ./src/forms/edChestPain01/Forms/EDChestPain-IntroForm.js